// Conversión formulario ⇄ documento de ffl_transfers y guardado de la armería
// en la base ffl_dealers (se guarda sola al usarla en una transferencia).
import { addDoc, collection, doc, getFirestore, serverTimestamp, updateDoc } from 'firebase/firestore';
import firebaseApp from '../../../utils/firebaseConfig';
import { centsToDollars, dollarsToCents, emptyDealer, emptyFirearm, suggestedFeeCents } from '../../../utils/transfers';

const db = getFirestore(firebaseApp);
const clean = (v, n) => String(v || '').trim().slice(0, n);

export const emptyForm = () => ({
  direction: 'receiving', dealer: emptyDealer(), firearms: [emptyFirearm()], fee: '125.00', feeTouched: false,
  invoiceNote: '', internalNotes: '', carrier: '', trackingNumber: '',
});

export const formFromTransfer = (t) => ({
  direction: t.direction || 'receiving',
  dealer: { ...emptyDealer(), ...(t.dealer || {}) },
  firearms: (t.firearms && t.firearms.length ? t.firearms : [emptyFirearm()]).map((f) => ({ kind: f.kind === 'long_gun' ? 'long_gun' : 'handgun', brand: f.brand || '', model: f.model || '', caliber: f.caliber || '', barrelLength: f.barrelLength || '', serialNumber: f.serialNumber || '', value: f.valueCents ? centsToDollars(f.valueCents) : '' })),
  fee: centsToDollars(t.feeCents || 12500), feeTouched: true,
  invoiceNote: t.invoiceNote || '', internalNotes: t.internalNotes || '', carrier: t.carrier || '', trackingNumber: t.trackingNumber || '',
});

// Campos del doc que salen del formulario (los de cliente/estado van aparte)
export const docFromForm = (v, customer = {}) => {
  const firearms = v.firearms.map((f) => ({ kind: f.kind === 'long_gun' ? 'long_gun' : 'handgun', brand: clean(f.brand, 80), model: clean(f.model, 80), caliber: clean(f.caliber, 40), barrelLength: clean(f.barrelLength, 40), serialNumber: clean(f.serialNumber, 80), valueCents: dollarsToCents(f.value) })).filter((f) => f.brand || f.model || f.serialNumber);
  const valueCents = firearms.reduce((s, f) => s + f.valueCents, 0);
  const d = v.dealer || emptyDealer();
  const dealer = { id: d.id || null, name: clean(d.name, 160), address: clean(d.address, 200), city: clean(d.city, 80), state: clean(d.state, 40).toUpperCase(), zip: clean(d.zip, 20), phone: clean(d.phone, 40), email: clean(d.email, 120).toLowerCase(), fax: clean(d.fax, 40), fflNumber: clean(d.fflNumber, 60), fflExpiration: clean(d.fflExpiration, 20) };
  const feeCents = v.feeTouched ? dollarsToCents(v.fee) : suggestedFeeCents(firearms);
  return {
    direction: v.direction === 'shipping' ? 'shipping' : 'receiving', dealer, firearms, valueCents, feeCents,
    invoiceNote: clean(v.invoiceNote, 500), internalNotes: clean(v.internalNotes, 2000), carrier: clean(v.carrier, 30), trackingNumber: clean(v.trackingNumber, 80),
    searchKey: [customer.code, customer.customerName, customer.customerPhone, customer.customerEmail, dealer.name, dealer.city, dealer.fflNumber, v.trackingNumber, ...firearms.flatMap((f) => [f.brand, f.model, f.serialNumber])].filter(Boolean).join(' ').toLowerCase(),
  };
};

// Guarda / actualiza la armería en ffl_dealers y devuelve el dealer con id.
export const upsertDealer = async (dealer, staff) => {
  if (!dealer || !dealer.name) return dealer;
  const data = { name: dealer.name, address: dealer.address, city: dealer.city, state: dealer.state, zip: dealer.zip, phone: dealer.phone, email: dealer.email, fax: dealer.fax, fflNumber: dealer.fflNumber, fflExpiration: dealer.fflExpiration, lastUsedAt: serverTimestamp(), updatedAt: serverTimestamp(), updatedBy: staff };
  if (dealer.id) {
    await updateDoc(doc(db, 'ffl_dealers', dealer.id), data).catch(() => {});
    return dealer;
  }
  const ref = await addDoc(collection(db, 'ffl_dealers'), { ...data, active: true, publicVisible: true, notes: '', createdAt: serverTimestamp(), createdBy: staff });
  return { ...dealer, id: ref.id };
};
